export default function BlkBlockLanding() {
  const heroImage = "/images/blk-block-hero.jpg";
  const donateUrl = "https://givebutter.com/theblkbloc";
  const pillars = [
    {
      t: "Market & Small Business",
      d: "Ownership. Circulation. Independence.",
    },
    {
      t: "Culture & Wellness",
      d: "Healing is part of the foundation.",
    },
    {
      t: "Housing & Stability",
      d: "Not temporary. Built to last.",
    },
    {
      t: "Education & Youth",
      d: "The future is trained here.",
    },
  ];

  const phases = [
    {
      phase: "Phase 1",
      t: "Prototype Block",
      d: "A small, working space (900–2000 sq ft) with a café or tea spot, small retail, children’s space, rotating vendors, and hands-on trade training.",
    },
    {
      phase: "Phase 2",
      t: "Community Activation",
      d: "Regular events, vendor days, youth programs, and growing foot traffic turn the prototype into a true destination.",
    },
    {
      phase: "Phase 3",
      t: "Build & Expand",
      d: "Using trained workers to create additional units—more shops, services, and structured business spaces.",
    },
    {
      phase: "Phase 4",
      t: "Full District",
      d: "A complete, walkable ecosystem with housing, commerce, wellness, and education fully integrated.",
    },
  ];

  const fuelItems = [
    {
      t: "Unity Stories",
      s: "Children’s books & cultural storytelling",
      href: "/books",
    },
  ];

  const programs = [
    {
      t: "Youth Gym & Leadership",
      d: "Sports, after-school, mentorship, tournaments, and strong community culture.",
    },
    {
      t: "Financial Literacy & Trading",
      d: "Practical wealth-building education for teens, adults, and future entrepreneurs.",
    },
    {
      t: "Tech & Creative Labs",
      d: "Coding, design, media, storytelling, and production pathways tied to real opportunity.",
    },
    {
      t: "Maternal Health & Wellness",
      d: "Clinic care, mental health, herbal care, nourishment, and whole-family support.",
    },
    {
      t: "Arts & Culture",
      d: "Galleries, film, festivals, performance, archives, and memory made visible.",
    },
    {
      t: "Small Business Incubator",
      d: "Co-working, micro-grants, vendor training, and pathways into ownership.",
    },
  ];

  return (
    <main className="min-h-screen bg-[#f7f2e8] text-[#181411]">
      {/* NAV */}
      <header className="sticky top-0 z-50 border-b border-black/5 bg-[#f7f2e8]/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-[#f4b544] via-[#c9732b] to-[#415b45]" />
            <div className="leading-tight">
              <p className="text-[11px] uppercase tracking-[0.25em] text-[#8a755d]">
                One Unity Rising
              </p>
              <p className="text-lg font-semibold tracking-tight">Blk Block</p>
            </div>
          </div>

          <nav className="hidden items-center gap-8 text-sm text-[#5b4f45] md:flex">
            <a href="#vision" className="transition hover:text-black">
              Vision
            </a>
            <a href="#fuel" className="transition hover:text-black">
              Fuel the Mission
            </a>
            <a href="/directory" className="transition hover:text-black">
              Directory
            </a>
            <a href="#programs" className="transition hover:text-black">
              Programs
            </a>
            <a href="#impact" className="transition hover:text-black">
              Impact
            </a>
            <a href="#involved" className="transition hover:text-black">
              Get Involved
            </a>
          </nav>

          <a
            href={donateUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-[#171310] px-5 py-2.5 text-sm font-medium text-white transition hover:bg-black"
          >
            Support the District
          </a>
        </div>
      </header>

      {/* HERO */}
      <section className="relative isolate overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(17,12,8,0.84)_0%,rgba(17,12,8,0.68)_38%,rgba(17,12,8,0.28)_68%,rgba(17,12,8,0.20)_100%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(17,12,8,0.75)_0%,rgba(17,12,8,0.2)_35%,rgba(17,12,8,0.25)_100%)]" />

        <div className="relative mx-auto grid min-h-[88vh] max-w-7xl items-end px-5 py-16 lg:grid-cols-[1.1fr_0.9fr] lg:px-8 lg:py-20">
          <div className="max-w-2xl text-white">
            <p className="mb-4 text-[11px] uppercase tracking-[0.32em] text-[#e9cfaa]">
              A Cultural & Economic District
            </p>

            <h1 className="max-w-3xl text-5xl font-semibold leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
              Rebuilding Black Wall Street for today.
            </h1>

            <p className="mt-6 max-w-xl text-base leading-7 text-white/82 sm:text-lg">
              Blk Block is a nonprofit vision to build thriving, walkable
              districts rooted in Black culture, ownership, wellness, education,
              and everyday beauty.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="#vision"
                className="rounded-full bg-[#f2ede4] px-6 py-3 text-sm font-medium text-[#16120f] transition hover:bg-white"
              >
                See the Vision
              </a>
              <a
                href={donateUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-white/20 bg-white/10 px-6 py-3 text-sm font-medium text-white backdrop-blur-sm transition hover:bg-white/15"
              >
                Fuel the District
              </a>
            </div>
          </div>


        </div>
      </section>

      {/* INTRO BAND */}
      <section className="border-t border-black/5 bg-[#171310] text-white">
        <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-start">
            <div>
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#d0b182]">
                The Vision
              </p>
              <h2 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl">
                More than a plaza.
              </h2>
            </div>
            <p className="max-w-3xl text-lg leading-8 text-white/78">
              Think Chinatown, but reimagined through Black America: a place
              where the architecture, sound, food, rhythm, ownership, and daily
              life all feel culturally rooted, modern, and unmistakably ours.
            </p>
          </div>
        </div>
      </section>

      {/* VISION */}
      <section id="vision" className="bg-[#f7f2e8]">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24">
          <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
            <div>
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#a88967]">
                District Vision
              </p>
              <h2 className="mt-3 max-w-md text-4xl font-semibold leading-tight tracking-tight sm:text-5xl">
                A self-sustaining cultural district.
              </h2>
              <p className="mt-6 max-w-md text-[17px] leading-8 text-[#5b4f45]">
                A pedestrian-first market street at the center, perimeter access
                for grocery and loading, housing above shops and nearby, and
                youth, wellness, and learning woven into everyday life.
              </p>
              </div>
            

            <div className="grid gap-5 sm:grid-cols-2">
              {pillars.map((p, i) => (
                <div
                  key={i}
                  className="rounded-[30px] border border-black/8 bg-white p-7 shadow-[0_10px_30px_rgba(0,0,0,0.04)]"
                >
                  <div className="mb-5 h-px w-16 bg-[#c7904a]" />
                  <h3 className="text-xl font-semibold tracking-tight">{p.t}</h3>
                  <p className="mt-3 text-sm leading-7 text-[#65584d]">{p.d}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-16 border-t border-black/8 pt-12">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <p className="text-[11px] uppercase tracking-[0.28em] text-[#a88967]">
                  Phased Rollout
                </p>
                <h3 className="mt-2 text-3xl font-semibold tracking-tight">
                  Built in visible steps.
                </h3>
              </div>
              <p className="max-w-xl text-sm leading-6 text-[#6d5f52]">
                A realistic rollout that starts with activation, grows through
                programs and enterprises, and builds toward a lasting district.
              </p>
            </div>

            <div className="mt-8 grid gap-4 lg:grid-cols-4">
              {phases.map((x, i) => (
                <div
                  key={i}
                  className="rounded-[28px] border border-black/8 bg-[#fbf8f2] p-6"
                >
                  <p className="text-sm font-semibold text-[#c07d2f]">{x.phase}</p>
                  <h4 className="mt-3 text-lg font-semibold text-[#2b241f]">
                    {x.t}
                  </h4>
                  <p className="mt-4 text-sm leading-7 text-[#4d433b]">{x.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FUEL */}
      <section id="fuel" className="bg-[#ece3d5]">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
          <div className="grid gap-10 lg:grid-cols-[0.75fr_1.25fr]">
            <div>
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#a88967]">
                Fuel the Mission
              </p>
              <h2 className="mt-3 text-4xl font-semibold tracking-tight">
                Every enterprise feeds the vision.
              </h2>
              <p className="mt-5 max-w-md text-[17px] leading-8 text-[#5f5348]">
                Products, services, and cultural offerings don’t sit outside the
                mission. They help fund, test, and grow the future district.
              </p>
            </div>

            <div className="grid gap-5 sm:grid-cols-3">
              {fuelItems.map((c, i) => (
                <a
                  key={i}
                  href={c.href}
                  className="group rounded-[28px] border border-black/8 bg-white p-5 transition hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)]"
                >
                  <div className="h-44 rounded-[22px] bg-[linear-gradient(135deg,#231b17,#564739,#a58355)]" />
                  <h3 className="mt-5 text-xl font-semibold tracking-tight">
                    {c.t}
                  </h3>
                  <p className="mt-2 text-sm leading-7 text-[#675a4e]">{c.s}</p>
                  <p className="mt-4 text-sm font-medium text-[#b8742b]">
                    Supports the District →
                  </p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PROGRAMS */}
      <section id="programs" className="bg-[#f7f2e8]">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#a88967]">
              Programs
            </p>
            <h2 className="mt-3 text-4xl font-semibold tracking-tight sm:text-5xl">
              Programs for our people.
            </h2>
            <p className="mt-5 text-[17px] leading-8 text-[#62564b]">
              These initiatives can begin now and scale naturally inside the
              district as land, buildings, and partnerships grow.
            </p>
          </div>

          <div className="mt-14 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
            {programs.map((card, i) => (
              <div
                key={i}
                className="rounded-[30px] border border-black/8 bg-white p-8 shadow-[0_10px_30px_rgba(0,0,0,0.04)]"
              >
                <div className="mb-6 h-px w-14 bg-[#d09448]" />
                <h3 className="text-2xl font-semibold leading-tight tracking-tight">
                  {card.t}
                </h3>
                <p className="mt-4 text-[15px] leading-7 text-[#685b50]">
                  {card.d}
                </p>
                <a
                  href="#involved"
                  className="mt-6 inline-block text-sm font-medium text-[#b8742b]"
                >
                  Get involved →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* IMPACT */}
      <section id="impact" className="bg-[#171310] text-white">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
<div>

  <h3 className="mt-3 text-3xl font-semibold tracking-tight">
    Built from the ground up.
  </h3>

              <div className="mt-8 grid grid-cols-3 gap-4">
                {[
                  { n: "0", l: "districts built" },
                  { n: "0", l: "permanent sites launched" },
                  { n: "1", l: "vision in motion" },
                ].map((s, i) => (
                  <div
                    key={i}
                    className="rounded-[24px] border border-white/10 bg-black/20 p-5 text-center"
                  >
                    <div className="text-3xl font-semibold">{s.n}</div>
                    <div className="mt-2 text-xs uppercase tracking-[0.18em] text-white/55">
                      {s.l}
                    </div>
                  </div>
                ))}
              </div>

              <p className="mt-6 text-sm leading-7 text-white/68">
                Blk Block is in its early building stage. This is the launch point —
                where vision becomes land, partnerships, programming, and a real
                district people can walk through, use, and grow with.
              </p>
              </div>
            </div>
       </section>

{/* GET INVOLVED */}
<section id="involved" className="bg-[#f7f2e8]">
  <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">

      <h3 className="mt-3 text-3xl font-semibold tracking-tight">
        Volunteer, partner, or sponsor.
      </h3>

      <p className="mt-4 max-w-lg text-[16px] leading-7 text-[#62564b]">
        Bring land, resources, program leadership, design expertise,
        youth support, wellness services, or aligned investment.
      </p>

      <div className="mt-8">
        <a
          href="https://stats.sender.net/forms/b2kAmK/view"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block rounded-full bg-[#171310] px-6 py-3.5 text-sm font-medium text-white transition hover:bg-black"
        >
          Submit Interest
        </a>
      </div>
  </div>
</section>
      {/* FOOTER */}
      <footer className="border-t border-black/8 bg-[#171310] text-white">
        <div className="mx-auto grid max-w-7xl gap-8 px-5 py-12 lg:grid-cols-2 lg:px-8">
          <div>
            <p className="text-lg font-semibold tracking-tight">Blk Block</p>
            <p className="mt-3 max-w-md text-sm leading-7 text-white/62">
              theblkblocteam@oneunityrising.org
            </p>
          </div>
          <div className="lg:text-right">
            <p className="text-sm text-white/72">
              © {new Date().getFullYear()} Blk Block
            </p>
            <p className="mt-2 text-sm text-white/45">
              Root House, Unity Stories, and other mission-aligned enterprises help
              build the district.
            </p>
          </div>
        </div>
      </footer>

    </main>

 );
}